module.exports = __webpack_public_path__ + "static/media/euchorthippus_declivus.8a1856f6.jpg";